import AbstractVideo from "video/AbstractVideo";
import VimeoVideo from "video/VimeoVideo";
import YoutubeVideo from "video/YoutubeVideo";

class VideoHelper {
    /**
     * Get video player from video json object
     *
     * @param {object} data
     * @param {jQuery} $element
     * @param {object} settings
     *
     * @return {AbstractVideo}
     */
    static process_json(data, $element, settings = {}) {
        let provider_id = data.provider.id;

        if ("undefined" === typeof VideoHelper.providers[provider_id]) {
            throw Error("Invalid video provider id: " + provider_id);
        }

        return new VideoHelper.providers[provider_id](data, $element, settings);
    }

    static process(provider, id, $element, settings = {}) {
        return VideoHelper.process_json({
            provider: {id: provider},
            customData: {id: id},
        }, $element, settings);
    }

    static register(provider_id, video) {
        VideoHelper.providers[provider_id] = video;
    }

    static get_video_details(url, provider = null) {
        if (provider === null) {
            provider = this.get_video_provider_details(url);
        }

        if (provider === null) {
            return Promise.reject("Unknown video url");
        }

        let videoId = provider.id;

        switch (provider.provider) {
            case VideoHelper.PROVIDER_YOUTUBE:
                return YoutubeVideo.get_video_details(videoId);
            case VideoHelper.PROVIDER_VIMEO:
                return VimeoVideo.get_video_details(videoId);
            default:
                return Promise.reject("Unknown video provider");
        }
    }

    static get_video_provider_details(url) {
        let result = null;
        $.each(VideoHelper.PROVIDERS, (id, providerData) => {
            if (result !== null) {
                return;
            }

            let regexResult = providerData.url.exec(url);
            if (regexResult !== null) {
                result = {
                    provider: parseInt(id),
                    id: regexResult[1],
                    displayUrl: providerData.displayUrl,
                };
            }
        });

        return result;
    }

}

VideoHelper.PROVIDER_YOUTUBE = 1;
VideoHelper.PROVIDER_VIMEO = 2;

VideoHelper.PROVIDERS = {
    [VideoHelper.PROVIDER_YOUTUBE]: {
        url: /(?:youtube\.com\/\S*(?:(?:\/e(?:mbed))?\/|watch\/?\?(?:\S*?&?v=))|youtu\.be\/)([a-zA-Z0-9_-]{6,11})/,
        displayUrl: "youtube.com",
    },
    [VideoHelper.PROVIDER_VIMEO]: {
        url: /(?:www\.|player\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/(?:[^\/]*)\/videos\/|album\/(?:\d+)\/video\/|video\/|)(\d+)(?:$|\/|\?)/,
        displayUrl: "vimeo.com",
    },
};

VideoHelper.providers = {};

export default VideoHelper;

VideoHelper.register(VideoHelper.PROVIDER_YOUTUBE, YoutubeVideo);
VideoHelper.register(VideoHelper.PROVIDER_VIMEO, VimeoVideo);

